// @flow

import React from 'react';
import { scroller } from 'react-scroll';
import { gql, graphql } from 'react-apollo';

import Staff from '~/components/content/Staff';

const StaffWithData = graphql(
    gql`
    query {
        contributors: users {
            id,
            name,
            description {
                brief {
                    md
                }
            },
            slug,
            avatar {
                secure_url
            },
        }
    }`,
    {
        props: ({ data: { contributors } }) => ({
            contributors,
        }),
    }
)(Staff);
export default class StaffContainer extends React.Component {
    props: {
        params: {
            slug: string,
        },
    };

    componentDidUpdate() {
        if (this.props.params.slug) {
            scroller.scrollTo(this.props.params.slug, {
                delay: 100,
                smooth: true,
            });
        }
    }

    render() {
        return <StaffWithData />;
    }
}



// WEBPACK FOOTER //
// ./src/components/content/StaffContainer.js